/**
 * Base class for all UI services, provides the interface that all UI services should implement.
 */
export class UIServiceBase {

    /**
     * Constructs a new instance of this UI service and initializes it.
     * @param {Boolean} delayInitialization Whether initialization should happen on next tick instead of during construction.
     */
    constructor(delayInitialization = false) {
        if (delayInitialization === false) {
            this.initializeService();
        } else {
            scheduleAtNextTick(() => {
                this.initializeService();
            });
        }
    }

    /**
     * Initializes the service.
     * Implementation details may vary between UI services.
     *
     * @abstract
     * @protected
     */
    initializeService() {
        throw new NotImplementedError();
    }

}

// ----------------------------------------------------------------------------

/** Thrown by UI services if a required element could not be found. */
export class ElementNotAvailableError extends Error {
}

/** Thrown if an unimplemented method was executed. */
export class NotImplementedError extends Error {
}

/**
 * Checks whether given value is a jQuery element or an array of
 * jQuery elements with at least one entry.
 *
 * @param {JQueryElement|null} element
 */
export function isElementAvailable(element) {
    return element && element.length && element.length > 0
}

// ----------------------------------------------------------------------------

export default UIServiceBase